import { IApplicationState } from '../../types/redux';
import { getBrokerFlow } from './getBrokerFlow';

export const getBrokerPartnerRewardsLanding = (state: IApplicationState): string | null => {
  const pageFlowType = getBrokerFlow(state);
  const isPartnerRewardsRegistered = state.newbuilding?.newbuildingBroker?.isPartnerRewardsRegistered;

  if (pageFlowType === 'withPartnerRewards' && !isPartnerRewardsRegistered) {
    return state.newbuilding?.newbuildingBroker?.partnerRewardsFlowUrl || null;
  }

  return null;
};
